
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from './controlador';
    import listado from './publicaciones-listado.vue';
    import buscador from './publicaciones-buscador.vue';
    import filtros_activos from './publicaciones-filtros-activos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            listado,
            buscador,
            filtros_activos,
          
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Vue.observable( Model ); }
        public get Modo() { return this.Controlador.Vista.Modo }
        public get Vista() { return this.Controlador.Vista; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Controlador.Buscador.Iniciar();
            await this.Controlador.Buscador.Buscar();
        }

    }
